var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "dropdown", staticClass: "mku-dropdown" },
    [
      _c(
        "div",
        {
          staticClass: "mku-dropdown__reference",
          on: {
            click: _vm.handleClick,
            mouseover: _vm.handleMounseover,
            mouseout: _vm.handleMounseout
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "mku-dropdown" } },
        [
          _c(
            "mku-drop",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visiable,
                  expression: "visiable"
                }
              ],
              ref: "dropdownMenu",
              staticClass: "mku-dropdown__content",
              attrs: { reference: "dropdown", placement: _vm.placement },
              nativeOn: {
                mouseenter: function($event) {
                  return _vm.handleMounseover($event)
                },
                mouseleave: function($event) {
                  return _vm.handleMounseout($event)
                }
              }
            },
            [_vm._t("menu")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }